const formatPercentage = number => {
  if (typeof number === 'string') {
    number = parseFloat(number);
  }
  if (isNaN(number)) {
    number = 0;
  }

  let formattedNumber = number.toFixed(2);
  return formattedNumber + '%';
};

export default formatPercentage;
